import { useCallback } from 'react';
import { useToast } from '@sorrem-client/ui/components';

/** The link that opens a crucible, by its invite code, in a friend's Crucibles tab, ready to Enter (#216). */
export function buildInviteLink(origin: string, inviteCode: string): string {
    return `${origin}/join/${encodeURIComponent(inviteCode)}`;
}

/** Copies an invite code to the clipboard and says whether it worked. */
export function useCopyInviteCode(): (code: string) => Promise<void> {
    const { showToast } = useToast();
    return useCallback(async (code: string): Promise<void> => {
        try {
            await navigator.clipboard.writeText(code);
            showToast({ message: `Invite code ${code} copied.`, severity: 'info' });
        } catch {
            showToast({ message: `Couldn't copy the code. Share this instead: ${code}`, severity: 'warning' });
        }
    }, [showToast]);
}

/** Copies an invite link to the clipboard and says whether it worked. */
export function useCopyInviteLink(): (link: string) => Promise<void> {
    const { showToast } = useToast();
    return useCallback(async (link: string): Promise<void> => {
        try {
            await navigator.clipboard.writeText(link);
            showToast({ message: 'Invite link copied. Send it to a friend to have them join.', severity: 'info' });
        } catch {
            showToast({ message: `Couldn't copy the link. Share this instead: ${link}`, severity: 'warning' });
        }
    }, [showToast]);
}
